import Component from '@glimmer/component';

export default class NoResults extends Component {}
